// src/components/LanguageSwitcher.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Menu, MenuItem, Tooltip, Typography, Box } from "@mui/material";
import TranslateIcon from "@mui/icons-material/Translate";

const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English",  flag: "🇬🇧" },
];

export default function LanguageSwitcher({ sx = {} }) {
  const { i18n, t } = useTranslation();
  const [anchor, setAnchor] = React.useState(null);
  const current = LANGS.find(l => l.code === i18n.language) || LANGS[0];

  return (
    <>
      <Tooltip title={t("lang.switch")}>
        <IconButton
          onClick={e => setAnchor(e.currentTarget)}
          size="small"
          sx={{ color: "inherit", gap: 0.5, ...sx }}
        >
          <TranslateIcon fontSize="small" />
          <Typography variant="caption" fontWeight={700} sx={{ display: { xs:"none", sm:"inline" } }}>
            {current.flag} {current.code.toUpperCase()}
          </Typography>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{ sx: { mt: 1, minWidth: 140, borderRadius: "10px" } }}
      >
        {LANGS.map(lang => (
          <MenuItem
            key={lang.code}
            selected={i18n.language === lang.code}
            onClick={() => { i18n.changeLanguage(lang.code); setAnchor(null); }}
            sx={{ gap: 1, fontWeight: i18n.language === lang.code ? 700 : 400 }}
          >
            <span>{lang.flag}</span>
            <span>{lang.label}</span>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
